import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'normalize-css/normalize.css';
import 'styles/global/reset.css';
import 'styles/global/main.scss';
import { ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import ContextSnackbar from 'ui/modules/Snackbar/ContextSnackbar';
import { bluePlanetTheme } from 'ui/theme';
import React from 'react';
import Routes from './routes';
import Auth0ProviderWithHistory from 'auth/Auth0ProviderWithHistory';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { logError } from 'util/logging';
import { setupGcpErrorHandlers } from 'util/gcpLogging';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import CookieConsent from './CookieConsent';
import { KeyboardNavigationProvider } from 'contexts/KeyboardNavigationContext';
import { NotificationProvider } from 'contexts/NotificationContext';
import { IntercomProvider } from 'contexts/IntercomContext';

// Set up global error handlers for capturing uncaught errors
setupGcpErrorHandlers();

axios.interceptors.response.use(
  response => response,
  (error: any) => {
    if (error.response && error.response.status >= 500) {
      logError(error);
    }

    return Promise.reject(error);
  },
);

const container = document.getElementById('app');
const root = createRoot(container!);

function App() {
  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={bluePlanetTheme}>
          <NotificationProvider>
            <IntercomProvider>
              <ContextSnackbar />
              <BrowserRouter>
                <Auth0ProviderWithHistory>
                  <KeyboardNavigationProvider>
                    <Routes />
                  </KeyboardNavigationProvider>
                </Auth0ProviderWithHistory>
              </BrowserRouter>
            </IntercomProvider>
          </NotificationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
      <CookieConsent />
    </>
  );
}

root.render(<App />);
